enum FieldType {
    text = 'text',
    textarea = 'textarea',
    select = 'select',
    selectRadio = 'selectRadio',
    selectCheckbox = 'selectCheckbox',
    selectCountry = 'selectCountry',
    file = 'file',
}

interface Field {
    name: string;
    label: string;
    type: FieldType;
    validations: any;
    colSpan?: number;
    default?: any;
}

interface ConsentsOptions {
    application: string;
    language: string;
}

interface FormOptions {
    consents: ConsentsOptions;
    validationMessages: { [key: string]: () => string };
}

const defaultOptions: FormOptions = {
    consents: {
        language: 'pl',
        application: '',
    },
    validationMessages: {
        required() {
            return 'Field is required'
        },
        checked() {
            return 'Must be checked'
        },
        email() {
            return 'Email is invalid'
        }
    }
}

class Form {
    fields: any[];
    options: FormOptions;

    constructor(fields: Field[], options = defaultOptions) {
        this.fields = fields;
        this.options = Object.assign({}, defaultOptions, options);
    }
}

export default Form;
export {FieldType};
